import {
  Swiper,
  Navigation,
  Pagination,
  Keyboard
} from 'swiper';

Swiper.use([Navigation, Pagination, Keyboard]);

const sliderSections = document.querySelectorAll(".s-broker-review-slide");

sliderSections.forEach(slideSection => {
  const slider = slideSection.querySelector(".s-broker-review-slide__slider");
  const buttonPrev = slideSection.querySelector(".swiper-button-prev");
  const buttonNext = slideSection.querySelector(".swiper-button-next");

  const swiperSettings = {
    navigation: {
      nextEl: buttonNext,
      prevEl: buttonPrev,
    },
    keyboard: true,
    draggable: true,
    slidesPerView: "auto",
    spaceBetween: 8,
    updateOnWindowResize: true,
    breakpoints: {
      767: {
        spaceBetween: 16
      },

    }
  };

  new Swiper(slider, swiperSettings);
});
